import React from "react";
import ReactDOM from "react-dom/client";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { settings } from "./settings";
import { BrowserRouter } from "react-router-dom";

/**
 * Bootstraps the React application.
 *
 * Initializes the MSAL PublicClientApplication, processes any pending redirect
 * response, sets the active account if one exists, then mounts the React tree
 * wrapped in MsalProvider and BrowserRouter.
 */
async function bootstrap() {
  const pca = new PublicClientApplication(settings);
  await pca.initialize();

  try {
    await pca.handleRedirectPromise();
  } catch (err) {
    console.error("handleRedirectPromise error:", err);
  }

  const active = pca.getActiveAccount();
  const all = pca.getAllAccounts();
  if (!active && all.length > 0) {
    pca.setActiveAccount(all[0]);
  }

  const rootEl = document.getElementById("root");
  const root = ReactDOM.createRoot(rootEl);

  root.render(
    <React.StrictMode>
      <MsalProvider instance={pca}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </MsalProvider>
    </React.StrictMode>
  );
}

bootstrap().catch((err) => {
  console.error("MSAL bootstrap failed:", err);
});

reportWebVitals();
